import { render, staticRenderFns } from "./teaserProducts.vue?vue&type=template&id=29b291af"
import script from "./teaserProducts.vue?vue&type=script&lang=ts"
export * from "./teaserProducts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementHeadline: require('/codebuild/output/src3458403893/src/acredo-website/components/element/elementHeadline.vue').default,ElementSnapSlider: require('/codebuild/output/src3458403893/src/acredo-website/components/element/elementSnapSlider.vue').default})
